import React from 'react'
import { Link } from 'gatsby'
import logo from '../../images/footerG1.png'

import {
  StyledFooter,
  Row,
  Column,
  FooterBottom,
  Links,
  Socials,
  Head,
} from './Footer.styles'

import Instagram from './primitives/Instagram'
import Youtube from './primitives/Youtube'
import LinkedIn from './primitives/LinkedIn'
import Facebook from './primitives/Facebook'

const Footer = ({ head, sub, buttons, headMax, subMax, headBgColor }) => {
  return (
    <>
      {head && (
        <Head headMax={headMax} subMax={subMax} headBgColor={headBgColor}>
          {head && <h2>{head}</h2>}
          {sub && <p>{sub}</p>}
          {buttons && <div>{buttons}</div>}
        </Head>
      )}
      <StyledFooter>
        <Row>
          <Column>
            <div className="logo">
              <a href="https://promazo.com">
                <img src={logo} alt="ProMazo logo and link to home" />
              </a>
            </div>
          </Column>
          <Column>
            <h1>EXPLORE</h1>
            <a href="https://workforce.promazo.com">Companies</a>
            <a href="https://mimino.promazo.com">Students</a>
            <a href="https://mentors.promazo.com">100k Challenge</a>
          </Column>
          <Column>
            <h1>COMPANY</h1>
            <a href="https://students.promazo.com/">Top 40 Students</a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://medium.com/promazo/"
            >
              Blog
            </a>
          </Column>
          <Column>
            <h1>CONTACT</h1>
            <div className="contact">
              <div>
                <p>General Inquiries</p>
                <a href="mailto:questions@promazo.com">questions@promazo.com</a>
              </div>
              <div>
                <p>Press Inquiries</p>
                <a href="mailto:media@promazo.com">media@promazo.com</a>
              </div>
              <div>
                <p>New Business</p>
                <a href="mailto:partnerships@promazo.com">
                  partnerships@promazo.com
                </a>
              </div>
              <div>
                <p>100k Mentor Partnerships</p>
                <a href="mailto:100kmentorchallenge@promazo.com">
                  100kmentorchallenge@promazo.com
                </a>
              </div>
            </div>
          </Column>
        </Row>
        <FooterBottom>
          <Links>
            <Link to="/privacy-policy/">Privacy</Link>
            <Link to="/terms-of-service/">Terms</Link>
            {/* <Link to="/">Use Policy</Link> */}
          </Links>
          <Socials>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UCocDOB6G3UktwSczPKL_ZEQ"
            >
              <Youtube />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/promazo/"
            >
              <Instagram />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/promazo/"
            >
              <LinkedIn />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/ProMazo/"
            >
              <Facebook />
            </a>
          </Socials>
        </FooterBottom>
      </StyledFooter>
    </>
  )
}

export default Footer
